import React, { useEffect, useCallback, useState} from 'react';
import {trim} from "utils/trim.js";
import {getBulkSampleInfo} from "components/sidebar/getSamples.js"
import Colors from 'components/Colors.js';
import {connect} from 'react-redux';
import ipfs from "decentralized/Ipfs.js";
import ethereum from 'decentralized/ethereum.js';
import './metadata.scss';

const colors = new Colors();
const presets = ethereum.presets;


const getNames = async (hashes) => {
    let names = {};
    for (let hash of hashes) {
        names[hash] = (await presets.getPresetTitle(hash));
    }
    return names;
};

const ProjectMetadata = ({projectHash, metadata}) => { 
    let thumbnail = metadata && metadata.thumbnail ? ipfs.getHashUrl(metadata.thumbnail) : undefined;
    let [presetNames, setPresetNames] = useState({});
    let [samples, setSamples] = useState([]);

    useEffect(() => {
        if (!metadata || !metadata.presets) {
            return;
        }
        getNames(metadata.presets).then(
            setPresetNames);
    }, [metadata, setPresetNames]);

    useEffect(() => {
        if (!metadata || !metadata.samples || metadata.samples.length === 0) {
            return;
        }
        getBulkSampleInfo(metadata.samples, projectHash).then(x => 
            setSamples(x.filter(x => x.name)));
    }, [metadata, setSamples, projectHash]);

    if (!metadata) {
        return '';
    }
    return (
        <div className="project-metadata">
          {thumbnail && <img src={thumbnail} className="project-thumbnail"/>}
          {Object.keys(presetNames).length > 0 && <div className="presets">
            {Object.keys(presetNames).map(x =>
                <div className="preset-name">
                  <div className="dot" style={{backgroundColor: colors.getColorForHash(x)}}/>
                  {presetNames[x]}
                </div>)}
                                                  </div>}
          {samples.length > 0 && <div className="samples">
                                   {samples.map(sample =>
                                       <div className="sample-name">
                                         {trim(sample.tags[0] || sample.name)}
                                       </div>)}
                                 </div>}
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProjectMetadata);
